import { useCurrentCampagne } from "@common/hooks/campagne";
import { OrganismeStatutType } from '@common/services';
import React from 'react';
import { Navigate, Outlet } from 'react-router-dom';
import { useInscriptionState } from '../hooks/use-inscription-state.hook';

export const RequireUnregisteredOrganisme = () => {
  const { organisme } = useInscriptionState();
  const { campagne } = useCurrentCampagne();

  if (!organisme) return <Navigate to={'/'} replace />;

  const isNotRefusOrDemandeInfo = organisme.statut
    && (organisme.statut !== OrganismeStatutType.REFUS)
    && (organisme.statut !== OrganismeStatutType.DEMANDE_INFORMATION);

  const appartenaitCampagnePrecedente = !!organisme.campagne?.annee
    && !!campagne?.annee
    && organisme.campagne.annee < campagne.annee;

  if (isNotRefusOrDemandeInfo && !appartenaitCampagnePrecedente) return <Navigate to={'/'} replace />;

  return <Outlet />;
};